import { Injectable } from '@angular/core';
import { SearchPageNames, DefaultSortTypeAndValue } from 'ep-bt-controls';

@Injectable({
  providedIn: 'root'
})
export class EpbtFaSortService {

  currentPageName = "";
  sortFlag: boolean = false;

  customerSortValue: string = DefaultSortTypeAndValue.Name;
  customerDirectionValue: number = DefaultSortTypeAndValue.Zero;
  customerSearchValue: string = null;//

  productSortValue: string = "";
  productDirectionValue: number = DefaultSortTypeAndValue.Zero;
  productSearchValue: string = null;//

  customerNotepadSortValue: string = DefaultSortTypeAndValue.DateTimeCreated;
  customerNotepadDirectionValue: number = DefaultSortTypeAndValue.One;

  dashboardNotepadSortValue: string = DefaultSortTypeAndValue.DateTimeCreated;
  dashboardNotepadDirectionValue: number = DefaultSortTypeAndValue.One;

  customerAddressSortValue: string = DefaultSortTypeAndValue.AddressCode;
  customerAddressDirectionValue: number = DefaultSortTypeAndValue.Zero;
  customerAddressSearchValue: string = "";//

  dashboardAddressSortValue: string = DefaultSortTypeAndValue.AddressCode;
  dashboardAddressDirectionValue: number = DefaultSortTypeAndValue.Zero;
  dashboardAddressSearchValue: string = "";//

  customerProductsPurchasedSortValue: string = DefaultSortTypeAndValue.ProductCode;
  customerProductsPurchasedDirectionValue: number = DefaultSortTypeAndValue.Zero;

  customerConatctSortValue: string = DefaultSortTypeAndValue.Name;
  customerConatctDirectionValue: number = DefaultSortTypeAndValue.Zero;
  customerConatctSearchValue: string = "";//

  dashboardConatctSortValue: string = DefaultSortTypeAndValue.Name;
  dashboardConatctDirectionValue: number = DefaultSortTypeAndValue.Zero;
  dashboardConatctSearchValue: string = "";//

  customerOpportunitySortValue: string = DefaultSortTypeAndValue.DateTimeCreated;
  customerOpportunityDirectionValue: number = DefaultSortTypeAndValue.Zero;

  dashboardOpportunitySortValue: string = DefaultSortTypeAndValue.DateTimeCreated;
  dashboardOpportunityDirectionValue: number = DefaultSortTypeAndValue.Zero;

  // documents type start
  customerOrderSortValue: string = DefaultSortTypeAndValue.OrderNumber;
  customerOrderDirectionValue: number = DefaultSortTypeAndValue.One;

  dashboardOrderSortValue: string = DefaultSortTypeAndValue.OrderNumber;
  dashboardOrderDirectionValue: number = DefaultSortTypeAndValue.One;

  customerQuoteSortValue: string = DefaultSortTypeAndValue.QuoteNumber;
  customerQuoteDirectionValue: number = DefaultSortTypeAndValue.One;

  dashboardQuoteSortValue: string = DefaultSortTypeAndValue.QuoteNumber;
  dashboardQuoteDirectionValue: number = DefaultSortTypeAndValue.One;

  customerTempOrderSortValue: string = DefaultSortTypeAndValue.OrderNumber;
  customerTempOrderDirectionValue: number = DefaultSortTypeAndValue.One;

  dashboardTempOrderSortValue: string = DefaultSortTypeAndValue.TemplateOrderNumber;
  dashboardTempOrderDirectionValue: number = DefaultSortTypeAndValue.One;

  customerCreditSortValue: string = DefaultSortTypeAndValue.CreditNoteNumber;
  customerCreditDirectionValue: number = DefaultSortTypeAndValue.One;

  dashboardCreditSortValue: string = DefaultSortTypeAndValue.CreditNoteNumber;
  dashboardCreditDirectionValue: number = DefaultSortTypeAndValue.One;

  customerInvoicesSortValue: string = DefaultSortTypeAndValue.InvoiceNumber;
  customerInvoicesDirectionValue: number = DefaultSortTypeAndValue.One;

  dashboardInvoicesSortValue: string = DefaultSortTypeAndValue.InvoiceNumber;
  dashboardInvoicesDirectionValue: number = DefaultSortTypeAndValue.One;

  customerStatementSortValue: string = DefaultSortTypeAndValue.StatementNumber;
  customerStatementDirectionValue: number = DefaultSortTypeAndValue.Zero;
  customerStatementSearchValue: string = "";//

  dashboardStatementSortValue: string = DefaultSortTypeAndValue.StatementNumber;
  dashboardStatementDirectionValue: number = DefaultSortTypeAndValue.Zero;

  dashboardStockSortValue: string = DefaultSortTypeAndValue.OrderNumber;
  dashboardStockDirectionValue: number = DefaultSortTypeAndValue.Zero;
  // documents type end


  supplierSortValue: string = DefaultSortTypeAndValue.Name;
  supplierDirectionValue: number = DefaultSortTypeAndValue.Zero;
  suppliertSearchValue: string = "";//
  isFromSorting: boolean = false;
  constructor() { }

  previousProductSearch: any = null;

  previousProductSearchForTransferOrOrder: any = null;


  setDefaultSortValues(pageName, isSelected: boolean = false) {
    switch (pageName) {
      case SearchPageNames.CustomerSearch:
        {
          this.customerSortValue = DefaultSortTypeAndValue.Name;
          this.customerDirectionValue = DefaultSortTypeAndValue.Zero;
          this.customerSearchValue = null;
          break;
        }
      case SearchPageNames.CustomerDetailsSearch:
        {
          this.customerNotepadSortValue = DefaultSortTypeAndValue.DateTimeCreated;
          this.customerNotepadDirectionValue = DefaultSortTypeAndValue.One;
          this.customerAddressSortValue = DefaultSortTypeAndValue.AddressCode;
          this.customerAddressDirectionValue = DefaultSortTypeAndValue.Zero;
          this.customerAddressSearchValue = null;
          this.customerProductsPurchasedSortValue = DefaultSortTypeAndValue.ProductCode;
          this.customerProductsPurchasedDirectionValue = DefaultSortTypeAndValue.Zero;
          this.customerConatctSortValue = DefaultSortTypeAndValue.Name;
          this.customerConatctDirectionValue = DefaultSortTypeAndValue.Zero;
          this.customerConatctSearchValue = null;
          this.customerOpportunitySortValue = DefaultSortTypeAndValue.DateTimeCreated;
          this.customerOpportunityDirectionValue = DefaultSortTypeAndValue.Zero;
          this.customerOrderSortValue = DefaultSortTypeAndValue.OrderNumber;
          this.customerOrderDirectionValue = DefaultSortTypeAndValue.One;
          this.customerQuoteSortValue = DefaultSortTypeAndValue.QuoteNumber;
          this.customerQuoteDirectionValue = DefaultSortTypeAndValue.One;
          this.customerTempOrderSortValue = DefaultSortTypeAndValue.OrderNumber;
          this.customerTempOrderDirectionValue = DefaultSortTypeAndValue.One;
          this.customerCreditSortValue = DefaultSortTypeAndValue.CreditNoteNumber;
          this.customerCreditDirectionValue = DefaultSortTypeAndValue.One;
          this.customerInvoicesSortValue = DefaultSortTypeAndValue.InvoiceNumber;
          this.customerInvoicesDirectionValue = DefaultSortTypeAndValue.One;
          this.customerStatementSortValue = DefaultSortTypeAndValue.StatementNumber;
          this.customerStatementDirectionValue = DefaultSortTypeAndValue.Zero;
          break;
        }

      case SearchPageNames.DashboardContactSearch:
        {
          this.dashboardConatctSortValue = DefaultSortTypeAndValue.Name;
          this.dashboardConatctDirectionValue = DefaultSortTypeAndValue.Zero;
          this.dashboardConatctSearchValue = null;
          break;
        }
      case SearchPageNames.DashboardOpportunitySearch:
        {
          this.dashboardOpportunitySortValue = DefaultSortTypeAndValue.DateTimeCreated;
          this.dashboardOpportunityDirectionValue = DefaultSortTypeAndValue.Zero;
          break;
        }
      case SearchPageNames.DashboardNotepadSearch:
        {
          this.dashboardNotepadSortValue = DefaultSortTypeAndValue.DateTimeCreated;
          this.dashboardNotepadDirectionValue = DefaultSortTypeAndValue.One;
          break;
        }
      case SearchPageNames.ProductSearch:
        {
          this.productSortValue = "";
          this.productDirectionValue = DefaultSortTypeAndValue.Zero;
          this.productSearchValue = null;
          this.previousProductSearch = null;
          this.previousProductSearchForTransferOrOrder = null;
          break;
        }
      case SearchPageNames.DashboardDocumentsSearch:
        {
          this.dashboardOrderSortValue = DefaultSortTypeAndValue.OrderNumber;
          this.dashboardOrderDirectionValue = DefaultSortTypeAndValue.One;
          this.dashboardQuoteSortValue = DefaultSortTypeAndValue.QuoteNumber;
          this.dashboardQuoteDirectionValue = DefaultSortTypeAndValue.One;
          this.dashboardTempOrderSortValue = DefaultSortTypeAndValue.TemplateOrderNumber;
          this.dashboardTempOrderDirectionValue = DefaultSortTypeAndValue.One;
          this.dashboardCreditSortValue = DefaultSortTypeAndValue.CreditNoteNumber;
          this.dashboardCreditDirectionValue = DefaultSortTypeAndValue.One;
          this.dashboardInvoicesSortValue = DefaultSortTypeAndValue.InvoiceNumber;
          this.dashboardInvoicesDirectionValue = DefaultSortTypeAndValue.One;
          this.dashboardStatementSortValue = DefaultSortTypeAndValue.StatementNumber;
          this.dashboardStatementDirectionValue = DefaultSortTypeAndValue.Zero;
          this.dashboardStockSortValue = DefaultSortTypeAndValue.OrderNumber;
          this.dashboardStockDirectionValue = DefaultSortTypeAndValue.Zero;
          break;
        }
    }
  }

  getProductDefaultValues() {
    this.productSortValue = "";
    this.productDirectionValue = DefaultSortTypeAndValue.Zero;
    this.productSearchValue = null;
  }
}
